module.exports = __webpack_public_path__ + "static/media/laporOn.40763cda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Components/Nav-Home/laporOn.svg
// module id = 63
// module chunks = 1